import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import handleOpenWhatsApp from 'services/whatsappService';

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant={'h2'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
      >
        ¿Listo para ser parte de la familia?
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
        color="textSecondary"
      >
        Forma parte de &quot;Pedro con las Mascotas&quot; y conecta con una comunidad que valora la lealtad, el cuidado y el bienestar real. Hagamos que tu marca sea el próximo paso positivo en la vida de quienes más queremos.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography variant="h5" color="textPrimary" sx={{ fontWeight: 700 }}>
                Menciones en estudio, segmentos de especialistas y contenido editorial: tu marca como aliado del bienestar animal.
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography variant="body1" component="p" color="textSecondary" sx={{ fontWeight: 400 }}>
                Pedro con las Mascotas, con Pedro Scutaro. Ellos también tienen una historia que contar.
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'flex-start' }}
            >
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={handleOpenWhatsApp}
                target={'_blank'}
              >
                Ser parte de la familia
              </Button>
              <Box marginTop={{ xs: 2, sm: 0 }} marginLeft={{ sm: 2 }} width={{ xs: '100%', md: 'auto' }}>
                <Button
                  component={'a'}
                  href="mailto:mercadeoyventas@tnonetwork.com"
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  mercadeoyventas@tnonetwork.com
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box height={'100%'} width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box height={'100%'} width={'100%'} maxHeight={600}>
              <Box
                component="img"
                src="https://files.tnonetwork.com/shows/cover/pedroconlasmascotas.png"
                alt="Pedro con las Mascotas - TNO Network"
                sx={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: 600,
                  objectFit: 'contain',
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Pedro con las Mascotas: Contenido con Corazón.
        </Typography>
      </Box>
      <Box marginTop={1} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
